import React from "react";
import { Box, Skeleton } from "@mui/material";

const SwapRebalanceValiditySkeleton = () => (
  <Box
    sx={{
      width: "100%",
      marginTop: 2,
      flex: 1,
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      overflow: "hidden",
      p: 4,
      boxSizing: "border-box",
    }}
  >
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexShrink: 0 }}>
      <Skeleton variant="text" width={160} height={32} /> {/* Filter dropdown skeleton */}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Skeleton variant="rectangular" width={120} height={40} /> {/* Normalize button */}
        <Skeleton variant="rectangular" width={180} height={40} /> {/* Final Submission button */}
      </Box>
    </Box>
    <Box sx={{ display: "flex", gap: 4, alignItems: "stretch", flex: 1, minHeight: 0, overflow: "hidden" }}>
      <Box sx={{ minWidth: 350, maxWidth: 400, width: "30%", display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}>
        <Box sx={{ display: "flex", mb: 1, flexShrink: 0 }}>
          <Skeleton variant="text" width={80} height={28} sx={{ mr: 2 }} />
          <Skeleton variant="text" width={80} height={28} sx={{ mr: 2 }} />
          <Skeleton variant="text" width={120} height={28} />
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        {[...Array(6)].map((_, i) => (
          <Box key={i} sx={{ display: "flex", mb: 1 }}>
            <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={80} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={120} height={24} />
          </Box>
        ))}
        </Box>
      </Box>
      <Box sx={{ minWidth: 600, flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}>
        <Box sx={{ display: "flex", mb: 1, flexShrink: 0 }}>
          <Skeleton variant="text" width={120} height={28} sx={{ mr: 2 }} />
          <Skeleton variant="text" width={160} height={28} sx={{ mr: 2 }} />
          <Skeleton variant="text" width={120} height={28} sx={{ mr: 2 }} />
          <Skeleton variant="text" width={120} height={28} />
        </Box>
        <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
        {[...Array(20)].map((_, i) => (
          <Box key={i} sx={{ display: "flex", mb: 1 }}>
            <Skeleton variant="text" width={120} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={160} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={120} height={24} sx={{ mr: 2 }} />
            <Skeleton variant="text" width={120} height={24} />
          </Box>
        ))}
        </Box>
      </Box>
    </Box>
  </Box>
);

export default SwapRebalanceValiditySkeleton; 